import { render, staticRenderFns } from "./UpdateFnAreaModal.vue?vue&type=template&id=1c901e9a&"
import script from "./UpdateFnAreaModal.vue?vue&type=script&lang=js&"
export * from "./UpdateFnAreaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports